import { TherapistAction } from '../../../src/redux/actions/constant';

export const therapistMigrateTaskAction = (payload: any) => {
  return {
    type: TherapistAction.THERAPIST_TASK_MIGRATE_REQUEST,
    payload,
  };
};

export const therapistMigrateTaskResetAction = () => {
  return {
    type: TherapistAction.THERAPIST_TASK_MIGRATE_RESET,
  };
};

export const migrateTherapisPatientAction = (payload: any) => {
  return {
    type: TherapistAction.MIGRATE_THERAPIST_PATIENT_REQUEST,
    payload,
  };
};

export const migrateTherapisPatientResetAction = () => {
  return {
    type: TherapistAction.MIGRATE_THERAPIST_PATIENT_RESET,
  };
};
